module.exports = __webpack_public_path__ + "img/icon-left.bd6e193b.svg";